import React, { FC, HTMLAttributes } from "react";
import { ElContactUsLite, ElContactUsLiteContent, ElColumn, elGapContactUsLite, ElColumnInside, ElBoxSubs, ElBoxSubsInside, ElHeaderSubTitle, ElDetails, elPad20 } from "./contact-us-lite.css";
import { Container } from "../../layout";
import { Icons } from "../../icons";
import { cx } from "@linaria/core";
import { elFlexAlignCenter } from "../../../@css-style";
import { ElHeadLine } from "../head-title";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";

interface IContactUsLiteProps extends HTMLAttributes<HTMLElement> {}

export const ContactUsLite: FC<IContactUsLiteProps> = ({ children, ...props }) => {
  return (
    <ElContactUsLite {...props}>
      <Container className={elGapContactUsLite}>
        <ElContactUsLiteContent>
          <ElHeadLine className={elFlexAlignCenter}>Contact Us</ElHeadLine>
        </ElContactUsLiteContent>
        <ElContactUsLiteContent>
          <ElColumn>
            <ElColumnInside className={cx(elPad20)}>
              <ElBoxSubs className={""} href="https://kumpul.id" target="_blank">
                <Icons icon={faGlobe} size="3x" color="#74B3DF" />
                <ElBoxSubsInside>
                  <ElHeaderSubTitle>Website KUMPUL</ElHeaderSubTitle>
                  <ElDetails>kumpul.id</ElDetails>
                </ElBoxSubsInside>
              </ElBoxSubs>
            </ElColumnInside>

            <ElColumnInside className={cx(elPad20)}>
              <ElBoxSubs className={""} href="https://www.instagram.com/kumpul_id/" target="_blank">
                <Icons icon={faInstagram} size="3x" color="#74B3DF" />
                <ElBoxSubsInside>
                  <ElHeaderSubTitle>Instagram KUMPUL</ElHeaderSubTitle>
                  <ElDetails>@kumpul_id</ElDetails>
                </ElBoxSubsInside>
              </ElBoxSubs>
            </ElColumnInside>

            <ElColumnInside className={cx(elPad20)}>
              <ElBoxSubs className={""} href="https://wa.me/628984336040" target="_blank">
                <Icons icon={faWhatsapp} size="3x" color="#74B3DF" />
                <ElBoxSubsInside>
                  <ElHeaderSubTitle>PIC Program</ElHeaderSubTitle>
                  <ElDetails>08984336040 (Admin Program)</ElDetails>
                </ElBoxSubsInside>
              </ElBoxSubs>
            </ElColumnInside>

            <ElColumnInside className={cx(elPad20)}>
              <ElBoxSubs className={""} href="mailto:Aprilia@kumpul.id?subject=Hello Aprilia" target="_blank">
                <Icons icon={"envelope"} size="3x" color="#74B3DF" />
                <ElBoxSubsInside>
                  <ElHeaderSubTitle>Email</ElHeaderSubTitle>
                  <ElDetails>Aprilia@kumpul.id</ElDetails>
                </ElBoxSubsInside>
              </ElBoxSubs>
            </ElColumnInside>
          </ElColumn>
        </ElContactUsLiteContent>
      </Container>
    </ElContactUsLite>
  );
};
